module.exports = __webpack_public_path__ + "static/media/decodificador_o.bb037c3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/decodificador_o.png
// module id = 1163
// module chunks = 0